// iPhone ouvert dans Safari : le web push n'y marche qu'une fois l'appli ajoutée
// à l'écran d'accueil (iOS 16.4+, 04-fiabilite-rappels). Gestes d'iOS 26, repris
// du guide Apple (support.apple.com/fr-fr/guide/iphone/iph42ab2f3a7/26/ios/26,
// relu le 2026-10-18, et iphea86e5236 « Transformer un site web en app ») :
// bouton Plus (icône ronde « ••• ») puis « Partager », ou Partager directement
// selon la disposition des onglets ; faire défiler jusqu'à « Sur l'écran
// d'accueil » (sinon « Modifier les actions ») ; activer « Ouvrir comme app
// web » ; Ajouter. Un geste par étape (FALC).
// Non vérifié sur un iPhone : l'appli posée sur l'écran d'accueil ne verrait pas
// le lien gardé par Safari (stockage séparé), d'où « Copier mon lien » d'abord.
import { Share } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Bouton, Texte, Titre } from '../components/base';
import { jetonCourant } from '../lib/jeton';

function Etape({ n, children }: Readonly<{ n: number; children: React.ReactNode }>) {
  return (
    <li className="flex gap-4 py-4">
      <span className="text-secondaire w-5 shrink-0 text-lg font-semibold tabular-nums">{n}</span>
      <span className="text-texte-long leading-relaxed">{children}</span>
    </li>
  );
}

function Precision({ children }: Readonly<{ children: React.ReactNode }>) {
  return <span className="text-secondaire mt-1 block text-sm">{children}</span>;
}

const ICONE = 'inline size-5 align-[-3px]';

export function GuideInstallation() {
  const { t } = useTranslation();
  const [copie, setCopie] = useState(false);
  const lien = `${window.location.origin}/i#${jetonCourant() ?? ''}`;

  const copier = async () => {
    try {
      await navigator.clipboard.writeText(lien);
      setCopie(true);
    } catch {
      setCopie(false);
    }
  };

  return (
    <section>
      <Titre>{t('installation.titre')}</Titre>
      <Texte>{t('installation.pourquoi')}</Texte>
      <Texte>{t('installation.lienCopie')}</Texte>
      <Bouton variante="secondaire" className="mt-4" onClick={() => void copier()}>
        {copie ? t('installation.copie') : t('installation.copier')}
      </Bouton>
      <ol className="divide-filet border-filet mt-6 divide-y border-y">
        <Etape n={1}>
          {t('installation.etape1')}
          <Precision>
            {t('installation.etape1Alt')}{' '}
            <Share aria-label={t('installation.partager')} className={ICONE} />
          </Precision>
        </Etape>
        <Etape n={2}>
          {t('installation.etape2')}
          <Precision>{t('installation.etape2Alt')}</Precision>
        </Etape>
        <Etape n={3}>{t('installation.etape3')}</Etape>
        <Etape n={4}>{t('installation.etape4')}</Etape>
        <Etape n={5}>{t('installation.etape5')}</Etape>
      </ol>
    </section>
  );
}
